import { render, staticRenderFns } from "./ProductSubscriptionsGrid.vue?vue&type=template&id=b2aa8058&lang=pug&"
import script from "./ProductSubscriptionsGrid.vue?vue&type=script&lang=js&"
export * from "./ProductSubscriptionsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports